import {emptyValidator, formValidator} from "../../validators";
const shiftGroupValidationStatus = {
    shgGroup: {
        validators: [emptyValidator()],
        name: "Group Name",
    },
    shgStakeholderType: {
        validators: [emptyValidator()],
        name: "Stakeholder Type",
    },
    shgStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    shgActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
}

export const shiftGroupValidation = (shiftGroup) => {
    return formValidator(shiftGroup, shiftGroupValidationStatus);
};

const shiftGroupStkValidationStatus = {
    sgcStakeholders: {
        validators: [emptyValidator()],
        name: "Stakeholders",
    },
    sgcStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    sgcActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
}

export const shiftGroupStkValidation = (shiftGroup) => {
    return formValidator(shiftGroup, shiftGroupStkValidationStatus);
};

const shiftGroupUserValidationStatus = {
    sguUserName: {
        validators: [emptyValidator()],
        name: "User",
    },
    sguStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    sguActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
}

export const shiftGroupUserValidation = (shiftGroup) => {
    return formValidator(shiftGroup, shiftGroupUserValidationStatus);
};
